// React and hooks
import React, { useEffect, useState, useRef } from 'react';

// Routing
import { NavLink } from 'react-router-dom';

// UI components
import { Row, Col, Dropdown, Button } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';

// Utilities
import { handleCatchError } from 'utils/handleErrors';

// Custom components
import ConnectionError from 'components/emptyStates/ConnectionError';
import CardOverweight from './components/CardOverweight';
import LoadingPulse from '../../../components/loading/LoadingPulse';
import LoadingCar from '../../../components/loading/LoadingCar';
import OverweightCSV from '../../../components/reactCsv/OverweightCSV';
import PaginateLocalStates from '../../../components/PaginateLocalStates';
import EmptyPage from '../../../components/emptyStates/EmptyPage';
import ProvisionalUserAlert from '../../../components/alerts/UserAlert';
import { ToastErrorApi } from '../../../components/alerts/toast';

// API services
import { getOverweightHistory } from '../../../api/Api-user';

const Overweight = () => {
  const title = 'Sobrepesos';
  const description = 'Sobrepesos Plataforma Autopaquete';
  //  const { currentUser } = useSelector((state) => state.auth);
  // -Local States
  const [overweights, setOverweights] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [changePage, setChangePage] = useState(1); // para la peticion
  const [changeItemsNum, setChangeItemsNum] = useState(10); // para la peticion
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [emptyHistory, setEmptyHistory] = useState(null);
  const [hasConnectionIssue, setHasConnectionIssue] = useState(false);
  // - Use references to do scroll Up
  const startRef = useRef(null);
  const handlerGetOverweight = async () => {
    try {
      if (overweights) {
        // solo si overweights es true [] activa este loader, si es falsy null usa el loader del car para los inicios
        setIsLoading(true);
      }
      const response = await getOverweightHistory(changePage, changeItemsNum);
      // console.log('response overweights:', response);
      if (response.overweights !== undefined) {
        setOverweights(response.overweights);
        setCurrentPage(response.current_page); // para actualizar la vista
        setPageSize(response.page_size); // para actualizar la vista
        setTotalPages(response.total_pages);
        if (startRef.current && startRef.current.scrollIntoView) {
          startRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (response.error) {
        setOverweights(overweights || []);
        setTotalPages(0);
        const firstKey = Object.keys(response.error)[0];
        const errorMessage = response.error.overweights[0].trim();
        if (!errorMessage.includes('No se encontraron envíos con los parámetros especificados.')) {
          // solo si es diferente a este error muestralo
          // es para que salga este mensaje cuando el historial esta vacio
          ToastErrorApi(response.error[firstKey]);
        } else {
          setEmptyHistory(overweights || true); // para mostrar mensaje de "No tienes historial"
          setMessage(
            '¡Todo en orden! No se detectaron sobrepesos. Recuerda que las paqueterías verifican el peso real de cada paquete y pueden aplicar cargos si hay diferencias con el peso declarado.'
          );
        }
      }
    } catch (error) {
      setOverweights(overweights || []);
      handleCatchError(error);
      setHasConnectionIssue(true); // only show component if this is true and history list is empty
    } finally {
      setIsLoading(false);
    }
  };

  const settingPage = (limit) => {
    // setIsLoading(true);
    setChangePage(1);
    setChangeItemsNum(limit);
  };
  useEffect(() => {
    handlerGetOverweight();
  }, [changePage, changeItemsNum]);
  // console.log('overweight:', overweights);
  return (
    <>
      {overweights === null && <LoadingCar />}
      {isLoading && <LoadingPulse />}
      <div id="pageContainer">
        <HtmlHead title={title} description={description} />
        <div className="page-title-container" ref={startRef}>
          <Row className="g-0">
            {/* Title Start */}
            <Col className="col-auto mb-3 mb-sm-0 me-auto">
              <NavLink className="muted-link pb-1 d-inline-block hidden breadcrumb-back" to="/">
                <CsLineIcons icon="chevron-left" size="13" />
                <span className="align-middle text-small ms-1">Inicio</span>
              </NavLink>
              <h1 className="mb-0 pb-0 display-4" id="title">
                {title}
              </h1>
            </Col>
            {/* Title End */}
            {/* Excel Buttons Start  crmId={currentUser.crmId} */}
            <Col sm="auto" className="d-flex align-items-end justify-content-end">
              {overweights?.length > 0 && (
                <Button
                  variant="primary"
                  className="w-auto btn btn-icon btn-icon-start ms-0 ms-sm-1"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://zfrmz.com/IyRVQ43hgBJu2op4LV3z');
                  }}
                >
                  <CsLineIcons icon="arrow-right" />
                  <span className="ps-2">Aclaración</span>
                </Button>
              )}
            </Col>
            {/* Excel  Buttons End */}
          </Row>
        </div>
        <div style={{ minHeight: '50vh' }} id="cardContainer">
          <Row className="g-0 bg-infox">
            <Col xs="12" sm="6" className="bg-warningx">
              {overweights?.length > 0 && (
                <Button
                  variant="primary"
                  className="w-auto btn btn-icon btn-icon-start ms-0 ms-sm-1 d-none"
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://zfrmz.com/IyRVQ43hgBJu2op4LV3z');
                  }}
                >
                  <CsLineIcons icon="arrow-right" />
                  <span className="ps-2">Aclaración</span>
                </Button>
              )}
            </Col>
            <Col xs="12" sm="6" className="mb-1 text-end bg-successx">
              {/* Excel Buttons  */}
              {overweights?.length > 0 && <OverweightCSV overweights={overweights} crmId="" />}
              {/* Dropdown  */}
              <Dropdown align={{ xs: 'end' }} className={`d-inline-block ms-1 ${overweights?.length < 10 && 'd-none'}`}>
                <Dropdown.Toggle variant="foreground-alternate" className="shadow sw-20">
                  {`${pageSize} Sobrepesos`}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow dropdown-menu-end">
                  <Dropdown.Item className={`${pageSize === 10 && 'd-none'}`} onClick={() => settingPage(10)}>
                    10 Sobrepesos
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 20 && 'd-none'}`} onClick={() => settingPage(20)}>
                    20 Sobrepesos
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 50 && 'd-none'}`} onClick={() => settingPage(50)}>
                    50 Sobrepesos
                  </Dropdown.Item>
                  {/* <Dropdown.Item className={`${pageSize === 100 && 'd-none'}`} onClick={() => settingPage(100)}>
                  100 Sobrepesos
                </Dropdown.Item> */}
                </Dropdown.Menu>
              </Dropdown>

              <div className={`${overweights?.length === 0 && 'invisible'} text-muted text-end my-3 `}>
                Página <strong>{currentPage}</strong>
              </div>
            </Col>
          </Row>
          <ProvisionalUserAlert title="Historial de sobrepesos" />
          {/* List Header Start */}
          <Row className="g-0 mb-2 d-none d-lg-flex">
            {/* <div className={`text-muted mb-3 ${overweights?.length === 0 && 'invisible'}`}>{`Página ${currentPage}`}</div> */}
            <Col xs="auto" className="sw-11 d-none d-lg-flex" />
            <Col>
              <Row className={`g-0 h-100 align-content-center custom-sort ps-5 pe-4 h-100 ${overweights?.length === 0 ? 'd-none' : 'd-flex'}`}>
                <Col xs="3" lg="4" className="d-flex flex-column mb-lg-0 pe-3 d-flex">
                  <div className="text-muted text-small cursor-pointer">SERVICIO / ID ENVÍO</div>
                </Col>
                <Col xs="2" lg="3" className="d-flex flex-column pe-1 justify-content-center">
                  <div className="text-muted text-small cursor-pointer">FECHA CARGO</div>
                </Col>
                <Col xs="2" lg="2" className="d-flex flex-column pe-1 justify-content-center align-items-lg-center">
                  <div className="text-muted text-small cursor-pointer">KG COBRADOS</div>
                </Col>
                <Col xs="2" lg="2" className="d-flex flex-column pe-1 justify-content-center align-items-lg-center">
                  <div className="text-muted text-small cursor-pointer">KG REALES</div>
                </Col>
                <Col
                  xs="2"
                  lg="1"
                  className="d-flex flex-column pe-1 justify-content mb-2 mb-lg-0 align-items-center order-2 order-lg-last justify-content-lg-center"
                >
                  <div className="text-muted text-small cursor-pointer">CARGO</div>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* List Header End */}
          <div style={{ minHeight: '60vh' }}>
            {overweights?.length === 0 && hasConnectionIssue && <ConnectionError refreshBtn />}
            {emptyHistory && <EmptyPage text={message} btnText="Ver más cargos adicionales" path="/información/recargos" isCallToAction />}
            {overweights?.length > 0 && (
              <>
                {/* List overweights Items Start */}
                {overweights?.map((overweight, index) => (
                  <CardOverweight key={index} overweight={overweight} />
                ))}
                {/* List overweights Items End */}
                {/* Pagination Start */}
                <div className={`d-flex flex-column justify-content-center align-items-center mt-5 mx-auto ${totalPages < 2 && 'd-none'}`}>
                  <PaginateLocalStates currentPage={currentPage} totalPages={totalPages} setCurrentPage={setChangePage} />
                </div>
                {/* Pagination End */}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Overweight;
